(function (window, document) {
  'use strict';

  const defaultOptions = {
    durationCssVariable: '--switch-button-transition-duration',
    activateCssClass: 'is--activate',
    activeCssClass: 'is--active',
    deactivateCssClass: 'is--deactivate',
    targetActivateCssClass: 'is--activate',
    targetActiveCssClass: 'is--active',
    targetDeactivateCssClass: 'is--deactivate',
    closeOnEscape: true,
    closeOnFocusOut: true,
    backdrop: false,
    backdropCssClass: 'backdrop',
    backdropCssClassModifier: 'switch-button',
    backdropActiveCssClass: 'backdrop--opened',
    backdropDeactivateCssClass: 'backdrop--close',
  };

  function SwitchButton(element, options) {

    // Mische die übergebenen Optionen mit den Standardoptionen
    this.options = Object.assign({}, defaultOptions, options);

    // Speichere das DOM-Element, auf das das Plugin angewendet wird
    this.element = element;

    // aktiv?
    this.active = false;

    // Ziel-Container
    this.targetElement = null;

    // Backdrop
    this.backdropElement = null;

    // Plugin intern initialisieren
    this.boot();
  }

  SwitchButton.prototype.boot = function() {
    const _ = this;

    if(this.element === null) {
      return;
    }

    if(this.element.hasAttribute('aria-controls') === true && document.querySelector('#' + this.element.getAttribute('aria-controls'))) {
      this.targetElement = document.querySelector('#' + this.element.getAttribute('aria-controls'));
    }

    if(this.element.classList.contains(this.options.activeCssClass) === true) {
      this.active = true;
    }

    this.element.addEventListener('click', function(event) {
      if(_.active === false) {
        _.activate();
      } else {
        _.deactivate();
      }
    });

    if(_.options.closeOnEscape === true) {
      document.addEventListener('keydown', function(event) {
        if(event.code === 'Escape' && _.active === true) {
          _.deactivate();
          _.element.focus();
        }
      });
    }

    // Focus nicht mehr im Container
    if(_.options.closeOnFocusOut === true) {
      document.addEventListener('keyup', function(event) {
        if(event.code === 'Tab' && _.active === true && _.targetElement.contains(event.target) === false) {
          _.deactivate();
        }
      });
    }

    this.element.addEventListener('switch-button.fire.activate', function(event) {
      _.activate();
    });

    this.element.addEventListener('switch-button.fire.deactivate', function(event) {
      _.deactivate();
    });
  }

  SwitchButton.prototype.getDuration = function() {
    let duration = parseInt(getComputedStyle(this.element).getPropertyValue(this.options.durationCssVariable));

    if(isNaN(duration) === true) {
      duration = 0;
    }

    return duration;
  }

  SwitchButton.prototype.getAriaLabel = function() {
    let ariaLabel = '';

    if(this.active === false) {
      ariaLabel = this.element.getAttribute('data-aria-label-open');

    } else {
      ariaLabel = this.element.getAttribute('data-aria-label-close');
    }

    return ariaLabel;
  }

  SwitchButton.prototype.createBackdrop = function() {
    const _ = this;

    if(_.backdropElement === null) {
      _.backdropElement = document.createElement('div');
      _.backdropElement.classList.add(_.options.backdropCssClass);

      if(_.options.backdropCssClassModifier !== '') {
        _.backdropElement.classList.add(_.options.backdropCssClass + '--' + _.options.backdropCssClassModifier);
      }

      _.backdropElement.addEventListener('click', function() {
        _.deactivate();
      });

      document.body.appendChild(this.backdropElement);
    }
  }

  SwitchButton.prototype.activate = function() {
    const _ = this;
    const duration = _.getDuration();

    if(_.active === false) {
      _.active = true;
      _.element.classList.add(_.options.activateCssClass);

      // Backdrop hinzufuegen
      // @todo: in Komponente auslagern
      if(_.options.backdrop === true) {
        _.createBackdrop();
        _.backdropElement.classList.add(_.options.backdropActiveCssClass);
      }

      // Aria-Attribute des Buttons anpassen
      _.element.setAttribute('aria-expanded', 'true');
      _.element.setAttribute('aria-label', _.getAriaLabel());

      // Ziel-Container einblenden
      _.targetElement.setAttribute('aria-hidden', 'false');
      _.targetElement.classList.add(_.options.targetActivateCssClass);

      mint.fireEvent('switch-button.activate', {
        targetElement: _.targetElement
      }, _.element);

      setTimeout(function() {
        _.activated();
      }, duration);
    }
  }

  SwitchButton.prototype.activated = function() {
    const _ = this;

    _.element.classList.add(_.options.activeCssClass);
    _.element.classList.remove(_.options.activateCssClass);

    _.targetElement.classList.add(_.options.targetActiveCssClass);
    _.targetElement.classList.remove(_.options.targetActivateCssClass);

    mint.fireEvent('switch-button.activated', {
      targetElement: _.targetElement
    }, _.element);
  }

  SwitchButton.prototype.deactivate = function() {
    const _ = this;
    const duration = _.getDuration();

    if(_.active === true) {
      _.active = false;
      _.element.classList.add(_.options.deactivateCssClass);
      _.element.classList.remove(_.options.activeCssClass);

      _.targetElement.classList.add(_.options.targetDeactivateCssClass);
      _.targetElement.classList.remove(_.options.targetActiveCssClass);

      if(_.options.backdrop === true) {
        _.backdropElement.classList.add(_.options.backdropDeactivateCssClass);
        _.backdropElement.classList.remove(_.options.backdropActiveCssClass);
      }

      // Aria-Attribute des Buttons anpassen
      _.element.setAttribute('aria-expanded', 'false');
      _.element.setAttribute('aria-label', _.getAriaLabel());

      // Ziel-Container einblenden
      _.targetElement.setAttribute('aria-hidden', 'true');

      mint.fireEvent('switch-button.deactivate', {
        targetElement: _.targetElement
      }, _.element);

      setTimeout(function() {
        _.deactivated();
      }, duration);
    }
  }

  SwitchButton.prototype.deactivated = function() {
    const _ = this;

    _.element.classList.remove(_.options.deactivateCssClass);
    _.targetElement.classList.remove(_.options.targetDeactivateCssClass);

    if(_.options.backdrop === true) {
      _.backdropElement.classList.remove(_.options.backdropDeactivateCssClass);
    }

    mint.fireEvent('switch-button.deactivated', {
      targetElement: _.targetElement
    }, _.element);
  }

  function initialize(element, options) {
    return new SwitchButton(element, options);
  }

  mint.components.switchButton = initialize;
})(window, document);
